module.exports = __webpack_public_path__ + "teqbahn-assets/media/41.fb9b0601.png";